import { AxiosResponse } from 'axios'
import { api } from 'boot/axios'
import {
  RawCampaign,
  Campaign,
  UseableStatus,
  Coupon,
  RawCoupon,
  CampaignDetail,
  AddressDelivery,
  RawAddressDelivery,
  CouponDetail,
} from './models'
import { generateMediaUrl } from '../helper'

export const getCampaignByCardId = async (
  cardId: number
): Promise<Campaign[]> => {
  const response: AxiosResponse<RawCampaign[]> = await api.get(
    `private/v1/coupon/campaign/${cardId}/`
  )

  return response.data.map(
    (elem) =>
      <Campaign>{
        id: elem.id,
        usableStatus: <UseableStatus>{
          usable: elem.usable_status.usable,
          error: elem.usable_status.error,
        },
        checkLimitNow: elem.check_limit_now,
        checkLimitMax: elem.check_limit_max,
        checkCurrentUse: elem.check_current_use,
        checkMaximumUse: elem.check_maximum_use,
        checkAvailable: elem.check_available,
        name: elem.name,
        description: elem.description,
        image: generateMediaUrl(elem.image),
        isActive: elem.is_active,
        availableTime: elem.available_time,
        startTime: elem.start_time,
        endTime: elem.end_time,
        couponExpireTime: elem.coupon_expire_time,
        isOverrideCode: elem.is_override_code,
        isAllowClaim: elem.is_allow_claim,
        isShowCountdown: elem.is_show_countdown,
        countdownTime: elem.countdown_time,
        campaignDisplay: elem.campaign_display,
        couponType: elem.coupon_type,
        conditionPoint: elem.condition_point,
        conditionLimitUseType: elem.condition_limit_use_type,
        conditionLimitUseValue: elem.condition_limit_use_value,
        conditionLimitPerCampaign: elem.condition_limit_per_campaign,
        conditionAvailableCoupon: elem.condition_available_coupon,
      }
  )
}

export const generateCouponByCardId = async (
  cardId: number,
  campaignId: number,
  quantity: number
): Promise<Coupon[]> => {
  const response: AxiosResponse<RawCoupon[]> = await api.post(
    `private/v1/coupon/campaign/${cardId}/`,
    {
      campaign_id: campaignId,
      quantity,
    }
  )
  return response.data.map(
    (elem) =>
      <Coupon>{
        id: elem.id,
        campaignName: elem.campaign_name,
        code: elem.code,
        usedExpiredAt: elem.used_expired_at,
        issuedAt: elem.issued_at,
        updatedAt: elem.updated_at,
        createdAt: elem.created_at,
      }
  )
}

export const getCoupon = async (): Promise<Coupon[]> => {
  const response: AxiosResponse<RawCoupon[]> = await api.get(
    'private/v1/coupon/wallet/'
  )
  return response.data.map(
    (elem) =>
      <Coupon>{
        id: elem.id,
        campaignName: elem.campaign_name,
        campaign: <CampaignDetail>{
          name: elem.campaign.name,
          description: elem.campaign.description,
          image: generateMediaUrl(elem.campaign.image),
        },
        code: elem.code,
        usedExpiredAt: elem.used_expired_at,
        expiredAt: elem.expired_at,
        issuedAt: elem.issued_at,
        updatedAt: elem.updated_at,
        createdAt: elem.created_at,
        checkAt: elem.check_at
      }
  )
}

export const activateCoupon = async (couponId: number): Promise<Coupon> => {
  const response: AxiosResponse<RawCoupon> = await api.post(
    `private/v1/coupon/wallet/activate/${couponId}/`
  )
  return <Coupon>{
    id: response.data.id,
    campaignName: response.data.campaign_name,
    code: response.data.code,
    usedExpiredAt: response.data.used_expired_at,
    issuedAt: response.data.issued_at,
    updatedAt: response.data.updated_at,
    createdAt: response.data.created_at,
  }
}

export const generateAddressDelivery = async(
  coupon: string | number,
  user?:  number,
  campaign?:  string | number,
  firstName?: string,
  lastName?: string,
  email?: string,
  address?: string,
  city?: string,
  zipcode?: string,
  phone?: string,
) => {
  const response = await api.post(
    'private/v1/coupon/campaign/address', 
    {
      coupon: coupon,
      user: user,
      campaign: campaign,
      first_name: firstName,
      last_name: lastName,
      email: email,
      address: address,
      city: city,
      zipcode: zipcode,
      phone: phone,
    }
  )
  return response
}

export const getAddressAddressDelivery = async(): Promise<AddressDelivery[]> => {
  const response: AxiosResponse<RawAddressDelivery[]> = await api.get(
    '/private/v1/coupon/campaign/address/'
  )
  
   const addressDeliveries: AddressDelivery[] = response.data.map((item) => {
  return {
    coupon: item.coupon,
    id: item.id,
    user: item.user,
    campaign: item.campaign,
    firstName: item.first_name,
    lastName: item.last_name,
    email: item.email,
    address: item.address,
    city: item.city,
    zipcode: item.zipcode,
    phone: item.phone,
    status: item.status,
    campaignDetail: item.campaign_detail.map(campaign => {
      return <CampaignDetail>{
        id: campaign.id,
        name: campaign.name,
      }
    }),
    couponDetail: item.coupon_detail.map(coupon=> {
      return <CouponDetail>{
        id: coupon.id,
        campaignName: coupon.campaign_name,
        code: coupon.code,
        usedAt: coupon.used_at
      }
    }),
    tracking: item.tracking,
    carrier: item.carrier
  }
 })
 
  return addressDeliveries
}

export default {
  getCampaignByCardId,
  generateCouponByCardId,
  getCoupon,
  activateCoupon,
}
